import img00 from '../assets/images/0000.png'
import img01 from '../assets/images/0001.png'
import img02 from '../assets/images/0002.png'
import { pickImage } from '../utils/helpers'

const defaultImages = [img00, img01, img02]

export default pickImage(defaultImages)
